import { notificationApi } from '@/api/notificationApi' 
export class ShowMessageActivity {
  constructor({store}, options) {
    this.options = options
    this.store = store
    this.NotificationApi = notificationApi
  }

  run() {
    let color = 'success'
    switch (this.options.Level) {
      case 1:
        color = 'warning'
        break
      case 2:
        color = 'error'      
    }
    this.NotificationApi.show({ text: this.options.Message, color })
  }
}